<template>
    <el-container>
        <el-header>
            <el-col :span="24">
                <span style="margin-top: 16px; display: inline-block;">{{ $t('actas.flujo_caja_vigente') }}</span>
            </el-col>
        </el-header>
        <el-main>
            <el-form :label-position="labelPosition">
                <el-row :gutter="4">
                    <el-col>
                        <el-form-item :label="$t('informe.initialDate')">
                            <el-date-picker v-model="fecha_inicial" type="month" format="yyyy-MM" placeholder="Seleccionar mes y año"></el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col>
                        <el-form-item :label="$t('informe.endDate')">
                            <el-date-picker v-model="fecha_final" type="month" format="yyyy-MM" placeholder="Seleccionar mes y año"></el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                    <div 
                        style="display: inline-flex; align-items: center; cursor: pointer; padding: 8px 16px; background-color: #409EFF; color: white; border-radius: 4px;" 
                        @click="obtenerDatos()">
                        <img :title="$t('xls')" style="width:32px; height: 36px;" :src="require('@/assets/xls.png')" />
                        <span style="margin-left: 8px;">Descargar Excel</span>
                    </div>
                    </el-col>
                </el-row>
            </el-form>
        </el-main>
    </el-container>
</template>
<script>
import { getFlujoCaja } from '@/api/acta_flujo_caja'
export default {
    data() {
        return {
            labelPosition: 'top',
            fecha_inicial: new Date(),
            fecha_final: new Date(),
            loading: false,
            acta_id: 3,
            tableData: []
        }
    },
    methods: {
        obtenerDatos() {
            this.loading = true
            const fecha_inicial_format = this.fecha_inicial.toISOString().split('T')[0];
            const fecha_final_format = this.fecha_final.toISOString().split('T')[0];
            getFlujoCaja(this.acta_id, fecha_inicial_format, fecha_final_format).then(resp => {
                if (resp.status === 200) {
                    var blob = resp.data
                    const filename = resp.headers['content-disposition'].split(';')[1].split('=')[1]
                    if (window.navigator.msSaveOrOpenBlob) {
                        window.navigator.msSaveBlob(blob, filename)
                    } else {
                        var downloadLink = window.document.createElement('a')
                        downloadLink.href = window.URL.createObjectURL(new Blob([blob], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }))
                        downloadLink.download = filename
                        document.body.appendChild(downloadLink)
                        downloadLink.click()
                        document.body.removeChild(downloadLink)
                    }
                } else {
                    this.$message({
                        message: 'No hay datos para generar acta en esta fecha: ' + this.$moment(this.fecha_corte).format('YYYY-MM-DD'),
                        type: 'warning'
                    })
                }
            }).catch(error => {
                this.loading = false
                console.log('Error Generando Actas Flujo Caja: ' + error)
            })
        }
    }
}
</script>
<style lang="scss" scoped>
.fa-icon {
    width: auto;
    height: 1em;
    /* or any other relative font sizes */

    /* You would have to include the following two lines to make this work in Safari */
    max-width: 100%;
    max-height: 100%;
}
</style>